export default "__VITE_ASSET__CxTy96x0__"